import React from "react";
import styles from "../../../styles/service-section-02.module.css";
import Image from "next/image";
import BlockContent from "@sanity/block-content-to-react";
import { GilroyFontDark, GilroyFontLight } from "@lib/GilroyFont";

const ServiceSectionFirst = ({ data }) => {
  const {
    first_heading_h2,
    first_paragraph_h3,
    hero_image,
    alt_text,
    first_list,
    second_list,
  } = data;

  return (
    <div className={styles.main_container}>
      <div className="max-w-[100rem] m-auto py-[3rem]">
        <div className="flex flex-col items-center">
          <div className={styles.items_container}>
            <div className={styles.items_container_second_div}>
              <div className=" flex justify-end lg:min-w-[50%] lg:max-w-[50%] ">
                <Image
                  style={{ width: "auto", height: "auto" }}
                  height={700}
                  width={700}
                  alt={alt_text}
                  src={hero_image}
                />
              </div>

              <div className={styles.items_container_first_div}>
                <h2
                  className={`text-start  text-white ${GilroyFontDark.className}  `}
                >
                  {" "}
                  {first_heading_h2.beforeStrong?.toUpperCase()}
                </h2>

                <h2 className={`${GilroyFontDark.className}`}>
                  <strong className="bg-white text-black ">
                    {first_heading_h2?.afterStrong?.toUpperCase()}
                  </strong>
                </h2>
                <span />

                {/* <p dangerouslySetInnerHTML={{ __html: first_paragraph_h3 }}></p> */}
                <BlockContent
                  blocks={first_paragraph_h3}
                  projectId="8l2jv7i6"
                  dataset="production"
                  serializers={{
                    types: {
                      block: (props) => {
                        switch (props.node.style) {
                          case "h1":
                            return (
                              <h1
                                initial={{ x: -100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                transition={{ duration: 0.75 }}
                                className="text-4xl font-bold py-3"
                              >
                                {props.children}
                              </h1>
                            );
                          case "h2":
                            return (
                              <h2 className="text-4xl font-bold py-3">
                                {props.children}
                              </h2>
                            );
                          case "h3":
                            return (
                              <h3 className="text-2xl font-semibold py-3">
                                {props.children}
                              </h3>
                            );
                          case "h4":
                            return (
                              <h4 className="text-xl font-semibold">
                                {props.children}
                              </h4>
                            );
                          case "h5":
                            return (
                              <h5 className="text-lg font-semibold ">
                                {props.children}
                              </h5>
                            );
                          case "h6":
                            return (
                              <h6 className="text-base font-semibold ">
                                {props.children}
                              </h6>
                            );
                          case "image":
                            return (
                              <Image
                                alt='meta title here'
                                className=""
                                src={props.children}
                              />
                            );
                          default:
                            return (
                              <p
                                className={`text-white text-[24px] w-[100%] ${GilroyFontLight.className} `}
                              >
                                {props.children}
                              </p>
                            );
                        }
                      },
                    },
                  }}
                />

                <div className={` ${second_list ? "sm:flex" : ""}  `}>
                  <ul
                    className={`flex flex-col space-y-2 py-[2rem] ${styles.custom_list}  `}
                  >
                    {first_list?.map((item, index) => (
                      <li
                        key={index}
                        dangerouslySetInnerHTML={{ __html: item.name }}
                      ></li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
//
export default ServiceSectionFirst;
